require('./aggregatorAccountMovementsView.scss');

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const { withRouter } = require('react-router-dom');
import { connect } from 'react-redux';
import { Map } from 'immutable';

import { AggregatorProductsGenericView } from '../aggregatorProductsGenericView/aggregatorProductsGenericView';

import { LastMovementsTable } from 'commonsComponents/lastMovementsTable';
import { OKTableRow } from 'commonsComponents/OKTableRow';
import { OKTableCell } from 'commonsComponents/OKTableCell';
import OKTooltip from 'components/commons/OKTooltip/OKTooltip';
import { OKBoxTitle } from 'commonsComponents/OKBoxTitle';
import { EmptyState } from 'commonsComponents/emptyState';
import { OKButton } from 'commonsComponents/OKButton';
import { LoadingSection } from 'commonsComponents/loadingSection';

import {
  getProductDetails,
  getTransactionsTink,
  requestNextPage,
} from 'actions/aggregator/aggregatorData';

import { LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY } from 'constants/commonsComponents';
import { NOT_ALLOWED_TINK_AGGREGATOR } from 'constants/flagBasedFeatures';
import { AggregatorAccountMovementsTableRow } from 'components/aggregator/aggregatorMovementsTableRow/aggregatorAccountMovementsTableRow';
import { AggregatorMovementsFilter } from 'components/aggregator/aggregatorMovementsFilter/aggregatorMovementsFilter';
import { AggregatorMovementsFilterTags } from 'components/aggregator/aggregatorMovementsFilter/aggregatorMovementsFilterTags';

import { OKHeaderSubPageDetails } from 'components/commons/OKHeaderSubPageDetails/OKHeaderSubPageDetails';
import { OKHeaderSubPageValue } from 'components/commons/OKHeaderSubPageValue/OKHeaderSubPageValue';

const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;

const language = getLanguage();

class AggregatorAccountMovementsViewClass extends React.PureComponent {
  componentWillMount() {
    const { getProductDetails, getTransactionsTink, history, product, isTinkAggregator } = this.props;

    const bankId = product.get('bank');
    const productType = product.get('product');
    const productId = product.get('id');

    if (!product || !bankId || !productId) {
      history.push('/myprofile/global/entities/accounts');
    } else {
      !isTinkAggregator
        ? getProductDetails(bankId, productType, productId)
        : getTransactionsTink(productType, productId);
    }
  }

  handleOnClickNext = () => {
    const { product, url, requestNextPage, getTransactionsTink, isTinkAggregator, hasMore } =
      this.props;
    const productType = product.get('product');
    const productId = product.get('id');

    !isTinkAggregator
      ? requestNextPage(productId, url)
      : getTransactionsTink(productType, productId, null, null, {}, url, hasMore);
  };

  handleOnClick = () => {
    const { getProductDetails, getTransactionsTink, product, url, isTinkAggregator } = this.props;

    const bankId = product.get('bank');
    const productType = product.get('product');
    const productId = product.get('id');

    !isTinkAggregator
      ? getProductDetails(bankId, productType, productId, url)
      : getTransactionsTink(productType, productId, null, null, {}, url);
  };

  getBreadcrumb = () => {
    return [
      {
        text: formatText('breadcrumb-global'),
        url: '/myprofile/global',
      },
      {
        text: formatText('breadcrumb-otherBanks'),
        url: '/myprofile/global/entities/accounts',
      },
      {
        text: formatText('breadcrumb-accounts'),
      },
    ];
  };

  renderError = () => {
    const primaryText = formatText('aggregatorMovements-error');
    const button = (
      <OKButton modifier="secondary" onClick={this.handleOnClick}>
        {formatText('aggregatorResume-retry')}
      </OKButton>
    );

    return (
      <div className="aggregator-movements-view__content__error">
        <EmptyState primaryText={primaryText} iconType="nointernet-banking" button={button} />
      </div>
    );
  };

  renderEmptyState = () => {
    const primaryText = formatText('aggregatorMovements-noMovements');

    return (
      <div className="aggregator-movements-view__content__noresults">
        <EmptyState primaryText={primaryText} iconType="search-banking" />
      </div>
    );
  };

  renderButtons = () => {
    const { hasMore } = this.props;

    if (!hasMore) return null;

    return (
      <div className="aggregator-movements-view__buttons">
        <OKButton onClick={this.handleOnClickNext}>
          <FormattedText value="aggregatorAccount-showMore" />
        </OKButton>
      </div>
    );
  };

  renderTable = () => {
    const { movements, immFlagBasedFeatures, isTinkAggregator } = this.props;

    if (!movements) return;

    const categoryFormattedText = (
      <span>
        <FormattedText value="myMoneyTransactions-category" format="firstUppercase" />
      </span>
    );
    const dateFormattedText = (
      <span>
        <FormattedText
          value="myMoneyTransactions-date"
          className="account-last-movements-table__cell-header-date"
          format="firstUppercase"
        />
      </span>
    );
    const categoryTooltip = (
      <OKTooltip
        content="myMoneyTransactions-categoryTooltip"
        offset={[0, -10]}
        target={categoryFormattedText}
        type="descriptive"
      />
    );

    const movementsById = movements.reduce((lv, cv, i) => lv.merge({ [i]: cv }), Map());
    const movementsByOrder = movements.map((v, i) => i.toString());

    return (
      <LastMovementsTable
        // immFilter={immFilter}
        groupByDate={true}
        rowComponent={AggregatorAccountMovementsTableRow}
        immTransactionsByOrder={movementsByOrder}
        immTransactionsById={movementsById}
        columnsCount={5}
        groupHeaderClassName={'aggregator-movements-view__table__group-header'}
        isExpandable={false}
        id={'aggregator-account-last-movements'}
        currentMonthKey={LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY}
        language={language}
        immFlagBasedFeatures={immFlagBasedFeatures}
        isTinkAggregator={isTinkAggregator}
      >
        <thead>
          <OKTableRow asHeader={true}>
            <OKTableCell asHeader={true}>
              <OKTooltip
                content="accounts-dateTooltip"
                offset={[0, -10]}
                target={dateFormattedText}
                type="descriptive"
              />
            </OKTableCell>
            <OKTableCell asHeader={true} className="text-center">
              {categoryTooltip}
            </OKTableCell>
            <OKTableCell asHeader={true}>
              <FormattedText value="myMoneyTransactions-description" format="firstUppercase" />
            </OKTableCell>
            <OKTableCell
              asHeader={true}
              className="aggregator-movements-view__table__cell-header-import"
            >
              <FormattedText value="myMoneyTransactions-amount" format="firstUppercase" />
            </OKTableCell>
            {
              // Tink doesn´t provide the relative balance
              !isTinkAggregator && (
                <OKTableCell
                  asHeader={true}
                  className="aggregator-movements-view__table__cell-header-balance"
                >
                  <FormattedText value="myMoneyTransactions-balance" format="firstUppercase" />
                </OKTableCell>
              )
            }
          </OKTableRow>
        </thead>
      </LastMovementsTable>
    );
  };

  renderContentHeader = () => {
    const { product, isTinkAggregator } = this.props;

    const productType = product.get('product');
    const productId = product.get('id');
    const bankId = product.get('bank');

    let headerTitle = <div>{formatText('accountMovements-movementsTitle')}</div>;

    return (
      <header className="aggregator-movements-view__header">
        <div className="row">
          <div className="aggregator-movements-view__header__title col-xs-6">
            <OKBoxTitle value={headerTitle} />
          </div>
          <div className="aggregator-movements-view__header__filters col-xs-6">
            <AggregatorMovementsFilter
              productType={productType}
              productId={productId}
              bankId={bankId}
              hasStatus={true}
              isTinkAggregator={isTinkAggregator}
            />
          </div>
        </div>
        <div>
          <AggregatorMovementsFilterTags
            productType={productType}
            productId={productId}
            bankId={bankId}
            isTinkAggregator={isTinkAggregator}
          />
        </div>
      </header>
    );
  };

  renderContent = () => {
    const { movements, loading, error } = this.props;

    if (error) return this.renderError();

    if (!loading && !movements) return this.renderEmptyState();

    return (
      <Fragment>
        {this.renderContentHeader()}
        {this.renderTable()}
        {loading && <LoadingSection />}
        {this.renderButtons()}
      </Fragment>
    );
  };

  renderHeader = extra => {
    const { product } = this.props;
    const value = product.get('balance');

    return (
      <OKHeaderSubPageDetails isSubPageOneLine={false}>
        <OKHeaderSubPageValue
          textKey="aggregator-accountViewItem"
          value={product && value}
          isAmountType={true}
        />
        {extra}
      </OKHeaderSubPageDetails>
    );
  };

  render() {
    const { product } = this.props;

    const title = product.get('alias');
    const subtitle = product.get('iban');

    return (
      <AggregatorProductsGenericView
        renderHeaderDetails={this.renderHeader}
        breadcrumb={this.getBreadcrumb()}
        title={title}
        subtitle={subtitle}
      >
        <div className="aggregator-movements-view__content">{this.renderContent()}</div>
      </AggregatorProductsGenericView>
    );
  }
}

AggregatorAccountMovementsViewClass.propTypes = {
  movements: PropTypes.object,
  history: PropTypes.object.isRequired,
  immFlagBasedFeatures: PropTypes.object,
  product: PropTypes.object,
  getProductDetails: PropTypes.func,
  getTransactionsTink: PropTypes.func,
  url: PropTypes.string,
  hasMore: PropTypes.bool,
  loading: PropTypes.bool,
  error: PropTypes.object,
  requestNextPage: PropTypes.func,
  isTinkAggregator: PropTypes.bool,
};

const AggregatorAccountMovementsView = withRouter(connect(
  (state, ownProps) => {
    const isTinkAggregator = state.flagBasedFeatures.get(NOT_ALLOWED_TINK_AGGREGATOR);

    const product = state.aggregatorData.getIn(['data', 'products', ownProps.match.params.id]);
    const movements = state.aggregatorData.getIn(
      ['details', ownProps.match.params.id, 'movements'],
      null
    );

    return {
      product,
      movements,
      url: state.aggregatorData.getIn(['details', ownProps.match.params.id, 'url'], null),
      hasMore: state.aggregatorData.getIn(['details', ownProps.match.params.id, 'hasMore'], false),
      loading: state.aggregatorData.getIn(['details', ownProps.match.params.id, 'loading'], false),
      error: state.aggregatorData.getIn(['details', ownProps.match.params.id, 'error'], null),
      immFlagBasedFeatures: state.flagBasedFeatures,
      isTinkAggregator,
    };
  },
  {
    getProductDetails,
    getTransactionsTink,
    requestNextPage,
  }
)(AggregatorAccountMovementsViewClass));

export { AggregatorAccountMovementsView };
